import { z } from "zod";

export const GetIntakeSubmissionTabsOutput = z.object({
  vendors: z.boolean(),
  services: z.boolean(),
  financialAnalysis: z.boolean(),
});

export type GetIntakeSubmissionTabsOutput = z.infer<
  typeof GetIntakeSubmissionTabsOutput
>;
